
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as abouthSDE9UaygRUZianECzLJPMwgq25wEzGs4piPS9hSDzIMeta } from "/home/runner/work/kasphub/kasphub/pages/about.vue?macro=true";
import { default as indexPK_QqF2hQgN5OedilWRl1MRqFjoaldMXYNoNbbyzmMQMeta } from "/home/runner/work/kasphub/kasphub/pages/index.vue?macro=true";
import { default as compare8fdeIV9CZZvohWFEdWqMI99nIOhWwNpKC286LTMDgx0Meta } from "/home/runner/work/kasphub/kasphub/pages/compare.vue?macro=true";
import { default as supportJ1qJ4Gk1F5SGS6q_ytIXxcEFQHZYai42z9P3Mi0LLkAMeta } from "/home/runner/work/kasphub/kasphub/pages/support.vue?macro=true";
import { default as indexCuTv_45mTdnsZ9iJlnuWp4A5Wl7p2pWJWDCgQ4oQoaeTUMeta } from "/home/runner/work/kasphub/kasphub/pages/blog/index.vue?macro=true";
import { default as calculatorKFFiaD79jMY55Zyg8osRVlctnyWp3a5f8L6OPk7N3EMMeta } from "/home/runner/work/kasphub/kasphub/pages/calculator.vue?macro=true";
import { default as tokenomicssFK42h6HsSEAHz_Md_45ViGSeSe7LbTHEQdiRjyTu8yjUMeta } from "/home/runner/work/kasphub/kasphub/pages/tokenomics.vue?macro=true";
import { default as _91slug_93atpm4D3yKs0RV6Si0Qi9MqiMtOS_7lOOuOWISa31WOYMeta } from "/home/runner/work/kasphub/kasphub/pages/blog/[slug].vue?macro=true";
import { default as indexzfvN5BiGnl8OLPWpxcS1ftlhhvZsGxHZjt94dEw9s0YMeta } from "/home/runner/work/kasphub/kasphub/pages/blog/categories/index.vue?macro=true";
import { default as _91slug_93AGnb262eSy4IQFJMdjyExoyry7kl0geIut86m6mJNrMMeta } from "/home/runner/work/kasphub/kasphub/pages/blog/categories/[slug].vue?macro=true";
import { default as component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8Meta } from "/home/runner/work/kasphub/kasphub/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8 } from "/home/runner/work/kasphub/kasphub/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___en",
    path: "/about",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/about.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/index.vue")
  },
  {
    name: "compare___en",
    path: "/compare",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/compare.vue")
  },
  {
    name: "compare___it",
    path: "/it/compare",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/compare.vue")
  },
  {
    name: "support___en",
    path: "/support",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/support.vue")
  },
  {
    name: "support___it",
    path: "/it/support",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/support.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/index.vue")
  },
  {
    name: "calculator___en",
    path: "/calculator",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/calculator.vue")
  },
  {
    name: "calculator___it",
    path: "/it/calculator",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/calculator.vue")
  },
  {
    name: "tokenomics___en",
    path: "/tokenomics",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/tokenomics.vue")
  },
  {
    name: "tokenomics___it",
    path: "/it/tokenomics",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/tokenomics.vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/[slug].vue")
  },
  {
    name: "blog-categories___en",
    path: "/blog/categories",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/categories/index.vue")
  },
  {
    name: "blog-categories___it",
    path: "/it/blog/categories",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/categories/index.vue")
  },
  {
    name: "blog-categories-slug___en",
    path: "/blog/categories/:slug()",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/categories/[slug].vue")
  },
  {
    name: "blog-categories-slug___it",
    path: "/it/blog/categories/:slug()",
    component: () => import("/home/runner/work/kasphub/kasphub/pages/blog/categories/[slug].vue")
  },
  {
    name: component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8
  },
  {
    name: component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8Meta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubLGiP3w4dfhcjcztX_K_joQ9p8_45XYtlAoI9ae8hMIEU8
  }
]